<template>
<b-modal ref="removeItem" title="Fjern">
  <form @submit.prevent="write">
    <div class="form-group">
      <label>Kategori:</label>
      <input v-model="item.category" type="text" class="form-control" readonly>
      <label>Gruppe:</label>
      <input v-model="item.group" type="text" class="form-control" readonly>
      <label>Type:</label>
      <input v-model="item.type" type="text" class="form-control" readonly>
      <label>Beskrivelse:</label>
      <textarea v-model="item.description" class="form-control" readonly />
      <label>Pris:</label>
        <input
          v-model="item.price"
          type="text"
          class="form-control"
          readonly>
      </div>
    </form>
    <template slot="modal-footer">
      <b-button
        variant="success"
        size="sm"
        @click="remove()">Fjern
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  db
} from '../../config/firebase';

export default {
  name: 'DeleteItem',
  components: {},
  data() {
    return {
      id: '',
      item: {
        category: '',
        group: '',
        type: '',
        description: '',
        price: ''
      }
    }
  },
  firebase: {
    products: db.ref('products')
  },
  methods: {
    show(item) {
      this.id = item['.key']
      this.item.category = item.category
      this.item.group = item.group
      this.item.type = item.type
      this.item.description = item.description
      this.item.price = item.price
      this.$refs.removeItem.show()
    },
    remove() {
      this.$firebaseRefs.products.child(this.id).remove();
      this.$refs.removeItem.hide()
    }
  }
}
</script>

<style scoped>
</style>
